module.exports = __webpack_public_path__ + "static/img/dev_p3.9da8fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_p3.png
// module id = a30b
// module chunks = 19